"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var PerfContext = /*#__PURE__*/React.createContext({
  renderWithProps: false
});
var _default = PerfContext;
exports.default = _default;